import filterConstants from '../../views/filter/constants';

export default {
  savedFilters: {},
  activeFilters: {},
  exportSessionFilterSnapshot: null,
  currentFilter: null,
  isOpen: false,
  isActive: false,
  isNotFound: false,
  isDisable: false,
  advancedSettings: {
    [filterConstants.FILTERS.reportsTimeMonth]: {
      isShowNotificationMessage: false,
    },
    [filterConstants.FILTERS.reportsBudgetMonth]: {
      isShowNotificationMessage: false,
    },
    [filterConstants.FILTERS.reportsProgressMonth]: {
      isShowNotificationMessage: false,
    },
    [filterConstants.FILTERS.reportsTimeProject]: {
      baselineEnabled: false,
      isShowNotificationMessage: false,
    },
    [filterConstants.FILTERS.reportsBudgetProject]: {
      baselineEnabled: false,
      isShowNotificationMessage: false,
    },
    [filterConstants.FILTERS.reportsProgressSchedule]: {
      baselineEnabled: false,
      isShowNotificationMessage: false,
    },
  },
};
